import script from "./demo-day-virtual-round.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-day-virtual-round.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__